import { FlagIcon } from '@repo/icons';
import { tr } from '@repo/locale';
import type { TestId } from '@repo/test-id';
import { Link } from 'react-router-dom';

import { selectStatus, useAuthStore } from '@features/auth';

import { SUPPORT_EMAIL } from '@shared/constants/constants';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

interface Props {
  testId: TestId;
}

export default function HelpButton({ testId }: Props) {
  const isLoggedIn = useAuthStore(selectStatus) === 'authenticated';

  const actionClassName = 'text-brand inline-flex items-center gap-1.5 px-3 py-2 text-sm leading-5 font-normal';
  const actionTestId = testId.append('action');

  return (
    <div className="flex items-center justify-center gap-2 text-sm" data-testid={testId}>
      <span className="text-body">{tr('help.need_help')}</span>
      {isLoggedIn ? (
        <Link to={ROUTE_PATHS[RouteName.ACCOUNT_TICKET_CREATE]} className={actionClassName} data-testid={actionTestId}>
          <FlagIcon className="size-4" aria-hidden />
          <span>{tr('help.write_to_us')}</span>
        </Link>
      ) : (
        <a href={`mailto:${SUPPORT_EMAIL}`} className={actionClassName} data-testid={actionTestId}>
          <FlagIcon className="size-4" aria-hidden />
          <span>{tr('help.write_to_us')}</span>
        </a>
      )}
    </div>
  );
}
